import { BsModalService } from 'ngx-bootstrap/modal'
import { AppState } from 'src/app/core/core.state'
import { BulkAction, BulkActionEvent } from 'src/app/shared/interfaces'

import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { Store } from '@ngrx/store'

import { OperationInternalEvent } from '../operation-internal-event'
import { operationInternalEventActions } from '../operation-internal-event.actions'
import { operationInternalEventSelectors } from '../operation-internal-event.selectors'
import { AccessRights } from 'src/app/features/role/user-role/user-role'
import { Observable } from 'rxjs'

@Component({
  selector: 'operation-internal-event-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss']
})
export class OperationInternalEventIndexComponent implements OnInit {
  public isLoading$: Observable<boolean>
  public operationInternalEvents$: Observable<OperationInternalEvent[]>
  public accessRights = AccessRights

  constructor(
    private modalService: BsModalService,
    private store: Store<AppState>,
    private router: Router
  ) {}

  ngOnInit() {
    this.store.dispatch(operationInternalEventActions.fetchMany({}))

    this.operationInternalEvents$ = this.store.select(
      operationInternalEventSelectors.selectAll
    )

    this.operationInternalEvents$ = this.store.select(
      operationInternalEventSelectors.selectAll
    )
  }

  public onClickRow(operationInternalEvent: OperationInternalEvent) {
    this.router.navigate([
      '/operation-internal-events',
      operationInternalEvent.id
    ])
  }

  public onClickCreate() {
    this.router.navigate(['/operation-internal-events/create'])
  }

  public onBulkAction(bulkActionEvent: BulkActionEvent) {
    if (bulkActionEvent.action == BulkAction.DELETE) {
      bulkActionEvent.items.forEach((i) =>
        this.store.dispatch(
          operationInternalEventActions.deleteOne({ id: i.id })
        )
      )
    }
  }
}
